import {
  CloseOutlined,
  CopyOutlined,
  DollarOutlined,
  LoadingOutlined,
  QuestionCircleOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { useWeb3Modal } from '@web3modal/wagmi/react'
import type { GetProp, TablePaginationConfig, TableProps, UploadFile, UploadProps } from 'antd'
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Progress,
  Row,
  Spin,
  Switch,
  Table,
  Tooltip,
  Upload,
} from 'antd'
import copy from 'copy-to-clipboard'
import React, { useEffect, useState } from 'react'
import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useAccount } from 'wagmi'

import abi from 'abi/abi-vesting.json'
import { AppAdmin } from 'api/app-admin'
import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { Noti } from 'component/noti/toast'
import { FEATURE } from 'constants/feature'
import { useContract } from 'hooks/contract/use-contract'
import { usePermission } from 'hooks/use-permission'
import dayjs from 'libs/dayjs'
import { convertTokenToWei, convertWeiToToken } from 'utils/contract'
import { logError } from 'utils/logger'

import './style.scss'

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0]

export default function AirdropDetails() {
  const { address } = useAccount()
  const locationParam = useParams()
  const code = locationParam.code || ''
  const [form] = Form.useForm()

  const [thumbnail, setThumbnail] = useState<string>('')
  const [singleFile, setSingleFile] = useState<UploadFile[]>([])
  const [sc, setSc]: any = useState('')

  const contract: any = useContract(sc, abi)
  const [loadingContract, setLoadingContract] = useState(false)

  const { canCRUD } = usePermission()

  // const importSingle = async (address: any, amount: any) => {
  //   try {
  //     if (contract) {
  //       setLoadingContract(true);
  //       await contract.addWhitelistMulti([address], [amount]).then((res: any) => {
  //         res?.wait().then(async (resWait: any) => {
  //           if (resWait?.status === 1) {
  //             getData();
  //             setLoadingContract(false);
  //             Noti('success', "Import whitelist successfully", 3000);
  //           } else {
  //             setLoadingContract(false);
  //             Noti('error', "Unknown error (status hash fail)", 3000);
  //           }
  //         }).catch((error: any) => {
  //           setLoadingContract(false);
  //           if (error?.code === 'ACTION_REJECTED') {
  //             Noti('error', 'User denied transaction signature', 3000);
  //           } else Noti('error', error?.error?.data?.message || error?.code || error?.message || error, 3000);
  //         })
  //       })
  //     } else {
  //       setLoadingContract(false);
  //       Noti('error', "Please connect wallet", 3000)
  //       return
  //     }
  //   } catch (error: any) {
  //     setLoadingContract(false);
  //     if (error?.code === 'ACTION_REJECTED') {
  //       Noti('error', 'User denied transaction signature', 3000);
  //     } else Noti('error', error?.error?.data?.message || error?.code || error?.message || error, 3000);
  //   }
  // }
  const [, setAllBatches] = useState<any[]>([])
  const [, setCurrentBacth] = useState(0)
  const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
  const [, setSuccessfulBatches] = useState(0)
  const [processedWallets, setProcessedWallets] = useState(0)

  const importWhiteList = async () => {
    try {
      if (!contract) {
        Noti('error', 'Please connect wallet', 3000)
        return
      }
      setLoadingContract(true)
      const BATCH_SIZE = 100
      const batches = []

      for (let i = 0; i < fullAddressList.length; i += BATCH_SIZE) {
        const addressBatch = fullAddressList.slice(i, i + BATCH_SIZE)
        const amountBatch = fullAmountList.slice(i, i + BATCH_SIZE)
        batches.push({ addressBatch, amountBatch })
      }

      setAllBatches(
        batches.map((_, index) => ({
          batch: index + 1,
          status: 'Not started',
          range: `${Math.min((index + 1) * BATCH_SIZE, fullAddressList.length)}`,
        }))
      )

      setSuccessfulBatches(0)
      setProcessedWallets(0)

      for (let i = 0; i < batches.length; i++) {
        const { addressBatch, amountBatch } = batches[i]
        setCurrentBacth(i + 1)

        try {
          setAllBatches((prev) =>
            prev.map((batch) => (batch.batch === i + 1 ? { ...batch, status: 'Pending' } : batch))
          )

          const res = await contract.addWhitelistMulti(addressBatch, amountBatch)
          const receipt = await res?.wait()

          if (receipt?.status === 1) {
            setSuccessfulBatches((prev) => prev + 1)
            setProcessedWallets((prev) => prev + addressBatch.length)
            setAllBatches((prev) =>
              prev.map((batch) => (batch.batch === i + 1 ? { ...batch, status: 'Success' } : batch))
            )
            Noti('success', `Batch ${i + 1} imported successfully`, 3000)
          } else {
            setAllBatches((prev) =>
              prev.map((batch) => (batch.batch === i + 1 ? { ...batch, status: 'Error' } : batch))
            )
            Noti('error', `Batch ${i + 1} failed: Unknown error (status hash fail)`, 3000)
          }
        } catch (error: any) {
          if (error?.code === 'ACTION_REJECTED') {
            setAllBatches((prev) =>
              prev.map((batch) =>
                batch.batch === i + 1
                  ? {
                      ...batch,
                      status: `Error - User denied transaction signature`,
                    }
                  : batch
              )
            )
            Noti('error', 'User denied transaction signature', 3000)
          } else {
            setAllBatches((prev) =>
              prev.map((batch) =>
                batch.batch === i + 1
                  ? {
                      ...batch,
                      status: `Error - ${
                        error?.error?.data?.message || error?.code || error?.message || error
                      }`,
                    }
                  : batch
              )
            )
            Noti(
              'error',
              error?.error?.data?.message || error?.code || error?.message || error,
              3000
            )
          }
        }

        if (i < batches.length - 1) {
          await delay(3000)
        }
      }

      await delay(3000)
      setLoadingContract(false)
      getWhiteList()
      setCurrent(1)
      setPageSize(10)
      getFullWhiteList()
    } catch (error: any) {
      setLoadingContract(false)
      if (error?.code === 'ACTION_REJECTED') {
        Noti('error', 'User denied transaction signature', 3000)
      } else {
        Noti('error', error?.error?.data?.message || error?.code || error?.message || error, 3000)
      }
    }
  }

  const handleUploadSingle = async (info: any) => {
    const { file } = info
    const formData = new FormData()
    formData.append('file', file)
    try {
      const response = await AppAdmin.uploadSingleFile(formData)
      if (response.data.success) {
        message.success('File uploaded successfully')
        setThumbnail(response.data.data.filePath)
        form.setFields([{ name: 'uploadSingle', errors: [] }])
      }
    } catch (error: any) {
      message.error(error?.message || 'File upload failed')
      logError('Upload error:', error)
    }
  }

  const beforeUploadSingle = async (file: FileType) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      form.setFields([{ name: 'uploadSingle', errors: ['You can only upload JPG/PNG file!'] }])
      return false
    }
    return true
  }

  const [tokenDecimal, setTokenDecimal] = useState(0)

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      const {
        name,
        isActive,
        contractAddress,
        startDate,
        endDate,
        tokenAddress,
        // tokenDecimal
      } = values

      await AppAdmin.updateAirDrop({
        code,
        name,
        contractAddress,
        desc: '',
        startDate,
        endDate,
        bannerUrl: thumbnail || '',
        isActive,
        tokenAddress,
        // tokenDecimal
      })
      message.success('Airdrop updated successfully!')
      getData()
      setEdit(false)
    } catch (error: any) {
      getData()
      message.error(error?.message || 'Error while submitting form')
      logError('Error while submitting form:', error)
    }
  }

  const handleCancel = () => {
    // navigate('/airdrop');
    setEdit(false)
    getData()
  }

  const [_showLocation, _setShowLocation] = useState(false)
  const [_infoContract, setInfoContract] = useState<any>({})
  const [_showInfo, _setShowInfo] = useState(false)

  const _getInfoContract = async (contractAddress: string) => {
    try {
      if (contractAddress) {
        const res = await AppAdmin.getInfoContract(contractAddress)
        if (res?.data.success) {
          setInfoContract(res?.data.data)
          message.success('Get contract address info success!')
        }
      }
    } catch (error: any) {
      message.error(error?.message || 'Contract address invalid')
      setInfoContract({})
      logError('Error: ', error)
    }
  }

  const additionalItems = [{ title: 'Airdrop', href: '/airdrop' }, { title: 'Details' }]

  const [startDate, setStartDate] = useState<any>(null)
  const [endDate, setEndDate] = useState<any>(null)

  const getAmoutSc = useCallback(
    async (address: any) => {
      try {
        if (contract) {
          const res = await contract.userInfo(address)
          return Number(res?.amount)
        }
      } catch (error) {
        logError(error)
        return 0
      }
    },
    [contract]
  )

  const getData = useCallback(async () => {
    try {
      const res = await AppAdmin.airDropDetails(code)
      if (res?.data.success) {
        const details = res?.data.data
        const formValues = {
          code: details?.code,
          name: details?.name,
          bannerUrl: details?.bannerUrl,
          desc: details?.desc,
          isActive: details?.isActive,
          startDate: dayjs.unix(details?.startTime).utc(),
          endDate: dayjs.unix(details?.endTime).utc(),
          contractAddress: details?.contractAddress,
          tokenAddress: details?.tokenAddress,
          // tokenDecimal: details?.tokenDecimal
        }
        setTokenDecimal(details?.tokenDecimal)
        setSc(details?.contractAddress)
        setStartDate(details?.startDate)
        setEndDate(details?.endDate)
        form.setFieldsValue(formValues)
        setThumbnail(details?.bannerUrl)
      }
    } catch (error) {
      logError(error)
    }
  }, [code, form])

  const [edit, setEdit] = useState(false)
  const [tab, setTab] = useState(0)

  const [data, setData] = useState<any[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [current, setCurrent] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [addressSearch, setAddressSearch] = useState('')
  const [fullAddressList, setFullAddressList] = useState<any>([])
  const [fullAmountList, setFullAmountList] = useState<any>([])
  const [totalUser, setTotalUser] = useState(0)
  const [totalToken, setTotalToken] = useState(0)

  const getFullWhiteList = useCallback(async () => {
    try {
      const res: any = await AppAdmin.getListWhiteList(code, 10000, 0)
      if (res?.data.success) {
        setTotalToken(res?.data?.data?.totalToken)
        setTotalUser(res?.data?.data?.totalUser)
        const listAmount = []
        const listAddress = []
        for (const [, item] of (res?.data?.data?.data ?? []).entries()) {
          // listAmount.push(web3.utils.toWei(item?.amount?.toString(), "ether"));
          listAmount.push(convertTokenToWei(item?.amount, tokenDecimal))
          listAddress.push(item?.ownerAddress)
        }
        setFullAddressList(listAddress)
        setFullAmountList(listAmount)
      }
    } catch (error) {
      logError('Error fetching data: ', error)
    }
  }, [code, tokenDecimal])

  const getWhiteList = useCallback(
    async (pageIndex = 1, pageSize = 10) => {
      setLoading(true)
      try {
        const res = await AppAdmin.getListWhiteList(code, pageSize, pageIndex - 1, addressSearch)
        if (res?.data.success) {
          const list = []
          for (const [index, item] of (res?.data?.data?.data ?? []).entries()) {
            const amountSc: any = await getAmoutSc(item?.ownerAddress)
            let formatted: any = 0
            if (amountSc || amountSc === 0) {
              // formatted = Number(web3.utils.fromWei(amountSc, "ether"));
              formatted = Number(convertWeiToToken(amountSc, tokenDecimal))
            } else formatted = null
            list.push({
              index: (pageIndex - 1) * pageSize + index + 1,
              key: `${pageIndex}-${index}`,
              ownerAddress: item?.ownerAddress,
              amount: item?.amount,
              amountSc: formatted,
              isActive: item?.isActive,
            })
          }
          setData(list)
          setTotal(res?.data.totalCount)
        }
      } catch (error) {
        setData([])
        setTotal(0)
        logError('Error fetching data: ', error)
      } finally {
        setLoading(false)
      }
    },
    [addressSearch, code, getAmoutSc, tokenDecimal]
  )

  const { open } = useWeb3Modal()

  const handleConnect = async () => {
    try {
      await open()
    } catch (error) {
      logError('Failed to connect wallet:', error)
    }
  }

  useEffect(() => {
    getWhiteList(current, pageSize)
  }, [current, pageSize, contract.address, addressSearch, address, getWhiteList])

  useEffect(() => {
    if (code) {
      getData()
      getFullWhiteList()
    }
  }, [code, getData, getFullWhiteList])

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current: newPage, pageSize: newPageSize } = pagination
    setCurrent(newPage || 1)
    setPageSize(newPageSize || 10)
  }
  // Define table columns
  const columns: TableProps<any>['columns'] = [
    {
      title: 'Index',
      dataIndex: 'index',
      key: 'index',
      width: 50,
    },
    {
      title: 'Address',
      dataIndex: 'ownerAddress',
      width: 500,
      key: 'ownerAddress',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <a target="_blank" rel="noreferrer" href={`https://basescan.org/address/${text}`}>
            {text}
          </a>
          <Tooltip title="Copy">
            <Button
              type="link"
              icon={<CopyOutlined />}
              onClick={() => {
                copy(text)
                message.success('Copied Success!')
              }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: 'Amount from File (MEY)',
      width: 300,
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Amount from SmartContract (MEY) ',
      dataIndex: 'amountSc',
      width: 300,
      key: 'amountSc',
      render: (text: any, record: any) => {
        const isEqual = record.amount === record.amountSc
        return (
          <div
            style={{
              backgroundColor: isEqual
                ? 'green'
                : loading
                  ? 'none'
                  : contract?.address
                    ? 'red'
                    : '#2b79f7',
              color: 'white',
              padding: '5px 10px',
              borderRadius: '4px',
              width: 'fit-content',
              cursor: contract?.address ? 'unset' : 'pointer',
              display: loading ? 'none' : 'unset',
            }}
            onClick={() => {
              if (!contract?.address) handleConnect()
            }}
          >
            {contract?.address && (record?.amountSc || record?.amountSc === 0)
              ? record?.amountSc
              : 'Connect wallet'}
          </div>
        )
      },
    },
    // {
    //   title: "Import SC",
    //   key: "importSc",
    //   width: 120,
    //   render: (text: any, record: any) => {
    //     const isEqual = record?.amount === record?.amountSc;
    //     return (
    //       !isEqual && (
    //         <div style={{ display: "flex", alignItems: "center" }}>
    //           <Button
    //             type="primary"
    //             style={{
    //               padding: "10px",
    //               backgroundColor: "#4CAF50",
    //               color: "white",
    //               borderRadius: "4px",
    //               display: loading ? 'none' : (contract?.address ? 'flex' : 'none'),
    //               alignItems: 'center',
    //               width: 100,
    //             }}
    //             disabled={loadingContract}
    //             onClick={() => {
    //               importSingle(record?.ownerAddress, record?.amount)
    //             }}
    //           >
    //             {loadingContract ? <Spin /> : 'Import SC'}
    //           </Button>
    //         </div>
    //       )
    //     );
    //   },
    // }
    // {
    //   title: "Address",
    //   dataIndex: "contractAddress",
    //   key: "contractAddress",
    //   render: (text) => (
    //     <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
    //       <a target="_blank" href={`https://basescan.org/address/${text}`}>{`${text.slice(0, 8)}...${text.slice(-8)}`}</a>
    //       <Tooltip title="Copy">
    //         <Button
    //           type="link"
    //           icon={<CopyOutlined />}
    //           onClick={() => {
    //             copy(text);
    //             message.success("Copied Success!");
    //           }}
    //         />
    //       </Tooltip>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Description",
    //   dataIndex: "desc",
    //   key: "desc",
    // },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      hidden: !contract?.address,
      // render: (status) =>
      //   status ? (
      //     <span className="status-success">Active</span>
      //   ) : (
      //     <span className="status-fail">Unactive</span>
      //   ),
      render: (text: any, record: any) => {
        const isEqual = record.amount === record.amountSc
        return (
          <>
            {isEqual && <span className="status-success">Valid</span>}
            {contract?.address && !isEqual && (record.amount || record?.amount === 0) && (
              <span className="status-fail">Error - Needs to re-import</span>
            )}
            {!contract?.address && <span className="status-pending">Need Import Whitelist</span>}
          </>
        )
      },
    },
  ]

  const [file, setFile] = useState([])
  const [isUploading] = useState(false)

  const handleUpload = async (info: any) => {
    const { file } = info
    const formData = new FormData()
    formData.append('file', file)
    try {
      const response = await AppAdmin.uploadWhitelist(formData, code)
      if (response.data.success) {
        message.success('File uploaded successfully')
        setFile(response.data.data.filePath)
        setCurrent(1)
        setPageSize(10)
        getWhiteList(1, 10)
        getFullWhiteList()
      }
    } catch (error: any) {
      message.error(error?.message || 'Please upload A valid CSV file')
      logError('Upload error:', error)
    }
  }

  const handleDownload = () => {
    const fileUrl = '/example.csv'
    const fileName = 'example.csv'
    const link = document.createElement('a')
    link.href = fileUrl
    link.download = fileName

    // Append the link to the document and trigger the download
    document.body.appendChild(link)
    link.click()

    // Clean up the DOM by removing the link
    document.body.removeChild(link)
  }

  const [isOwner, setIsOwner] = useState(false)

  const ownerCheck = useCallback(async () => {
    try {
      if (contract) {
        const res = await contract.whitelistManagers(address)
        setIsOwner(res)
      } else {
        setIsOwner(false)
      }
    } catch (error: any) {
      setIsOwner(false)
      logError(error)
    }
  }, [address, contract])

  useEffect(() => {
    if (address && contract?.address) {
      ownerCheck()
    }
  }, [address, contract?.address, ownerCheck])

  return (
    <div className="p2p-create">
      <Breadcrumb additionalItems={additionalItems} />
      <div className="tab-group">
        <p
          className={tab === 0 ? 'selected' : ''}
          onClick={() => {
            setTab(0)
            setEdit(false)
            getData()
          }}
        >
          Details
        </p>
        <p
          className={tab === 1 ? 'selected' : ''}
          onClick={() => {
            setTab(1)
            setEdit(false)
            getWhiteList()
          }}
        >
          Whitelist
        </p>
      </div>
      {tab === 0 && (
        <Form
          form={form}
          layout="vertical"
          initialValues={{ remember: true }}
          style={{ padding: '20px 10px' }}
          onFinish={handleOk}
        >
          <div style={{ textAlign: 'start', paddingBottom: 10 }}>
            {!edit ? (
              <Button
                disabled={!canCRUD(FEATURE.AIRDROP)}
                style={{ marginRight: 15, width: 100 }}
                key="edit"
                onClick={() => setEdit(true)}
                type="primary"
              >
                Edit
              </Button>
            ) : (
              <>
                <Button style={{ marginRight: 15, width: 100 }} key="back" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button
                  disabled={thumbnail.length === 0}
                  style={{ width: 100 }}
                  key="submit"
                  type="primary"
                  htmlType="submit"
                >
                  Save
                </Button>
              </>
            )}
          </div>
          <fieldset>
            <legend>Basic Information</legend>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label={
                    <>
                      Name
                      <Tooltip
                        title={
                          <div className="tooltip-box">
                            <p className="tooltip-text">
                              This is your Airdrop name, please enter your chosen name as text
                            </p>
                          </div>
                        }
                        placement="right"
                        overlayInnerStyle={{
                          backgroundColor: '#ffffff',
                        }}
                      >
                        <QuestionCircleOutlined className="tooltip-icon" />
                      </Tooltip>
                    </>
                  }
                  name="name"
                  rules={[
                    { required: true, message: 'Please input the name!' },
                    {
                      min: 3,
                      max: 50,
                      message: 'Name should be between 3 and 50 characters!',
                    },
                  ]}
                >
                  <Input disabled={!edit} placeholder="Enter the name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={
                    <>
                      Status
                      <Tooltip
                        title={
                          <div className="tooltip-box">
                            <p className="tooltip-text">
                              Toggle the switch to manage your Airdrop status. When the switch is{' '}
                              <strong>ON</strong>, the Airdrop is active. When the switch is{' '}
                              <strong>OFF</strong>, the Airdrop is inactive.
                            </p>
                          </div>
                        }
                        placement="right"
                        overlayInnerStyle={{
                          backgroundColor: '#ffffff',
                        }}
                      >
                        <QuestionCircleOutlined className="tooltip-icon" />
                      </Tooltip>
                    </>
                  }
                  name="isActive"
                  required
                >
                  <Switch disabled={!edit} />
                </Form.Item>
              </Col>
              <Col style={{ marginBottom: 12 }} span={12}>
                <Form.Item
                  label={
                    <>
                      Pool Contract Address
                      <Tooltip
                        title={
                          <div className="tooltip-box">
                            <p className="tooltip-text">
                              This is your Airdrop contract address, please enter the correct pool
                              contract address.
                            </p>
                          </div>
                        }
                        placement="right"
                        overlayInnerStyle={{
                          backgroundColor: '#ffffff',
                        }}
                      >
                        <QuestionCircleOutlined className="tooltip-icon" />
                      </Tooltip>
                    </>
                  }
                  name="contractAddress"
                  rules={[
                    {
                      required: true,
                      message: 'Please input the contract address!',
                    },
                  ]}
                  style={{ marginBottom: 12 }}
                >
                  <Input disabled={!edit} placeholder="Enter the contract address" />
                </Form.Item>
              </Col>
              <Col style={{ marginBottom: 12 }} span={12}>
                <Form.Item
                  label={
                    <>
                      Token Address
                      <Tooltip
                        title={
                          <div className="tooltip-box">
                            <p className="tooltip-text">
                              This is your Airdrop token address, please enter the correct token
                              address
                            </p>
                          </div>
                        }
                        placement="right"
                        overlayInnerStyle={{
                          backgroundColor: '#ffffff',
                        }}
                      >
                        <QuestionCircleOutlined className="tooltip-icon" />
                      </Tooltip>
                    </>
                  }
                  name="tokenAddress"
                  rules={[
                    {
                      required: true,
                      message: 'Please input the token address!',
                    },
                  ]}
                  style={{ marginBottom: 12 }}
                >
                  <Input disabled={!edit} placeholder="Enter the token address" />
                </Form.Item>
              </Col>
              {/* <Col style={{ marginBottom: 12 }} span={12}>
              <Form.Item
                label={
                  <>
                    Token Decimal
                    <Tooltip
                      title={
                        <div className="tooltip-box">
                          <p className="tooltip-text">
                            This is your Airdrop token decimal, please
                            enter the correct token decimal
                          </p>
                        </div>
                      }
                      placement="right"
                      overlayInnerStyle={{
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <QuestionCircleOutlined className="tooltip-icon" />
                    </Tooltip>
                  </>
                }
                name="tokenDecimal"
                rules={[
                  {
                    required: true,
                    message: "Please input the token decimal!",
                  },
                ]}
                style={{ marginBottom: 12 }}
              >
                <Input disabled={!edit} type="number" min={0} placeholder="Enter the token decimal" />
              </Form.Item>
            </Col> */}
              {/* <Col span={12}><Button
            style={{ marginTop: 30 }}
            htmlType="button"
            onClick={() => {
              if (showInfo) {
                setShowInfo(!showInfo)
              } else {
                setShowInfo(!showInfo)
                getInfoContract(form.getFieldValue("contractAddress"))
              }
            }}
          >
            {!showInfo ? "View Info" : "Hide Info"}
          </Button></Col>
          <Col span={24}>
            {infoContract && showInfo && (
              <div className="info-contract">
                <Title style={{ marginTop: 0 }} level={4}>
                  Contract Information
                  <Tooltip
                    title={
                      <div className="tooltip-box">
                        <p className="tooltip-text">
                          This is your PTO address information, check the data below
                        </p>
                      </div>
                    }
                    placement="right"
                    overlayInnerStyle={{
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <InfoCircleOutlined className="tooltip-icon" />
                  </Tooltip>
                </Title>
                <Descriptions
                  bordered
                  column={1}
                  style={{ marginBottom: "16px" }}
                >
                  <Descriptions.Item label="APY">
                    {infoContract.apy}
                  </Descriptions.Item>
                  <Descriptions.Item label="Boots APY">
                    {infoContract.boots_apy}
                  </Descriptions.Item>
                  <Descriptions.Item label="Funding Target">
                    {infoContract.fundingTarget}
                  </Descriptions.Item>
                  <Descriptions.Item label="Start Time">
                    {infoContract.startDate}
                  </Descriptions.Item>
                  <Descriptions.Item label="End Time">
                    {infoContract.endDate}
                  </Descriptions.Item>
                </Descriptions>
              </div>
            )}
          </Col> */}
              {/* <Col span={24}>
              <Form.Item
                label={
                  <>
                    Description
                    <Tooltip
                      title={
                        <div className="tooltip-box">
                          <p className="tooltip-text">
                            This is your Airdrop description, please enter
                            your chosen description as text
                          </p>
                        </div>
                      }
                      placement="right"
                      overlayInnerStyle={{
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <QuestionCircleOutlined className="tooltip-icon" />
                    </Tooltip>
                  </>
                }
                name="desc"
                rules={[
                  // { required: true, message: "Please input the description!" },
                  {
                    min: 3,
                    max: 150,
                    message: "Description should be between 3 and 150 characters!",
                  },
                ]}
              >
                <Input.TextArea disabled={!edit} rows={4} placeholder="Enter the description" />
              </Form.Item>
            </Col> */}
            </Row>
          </fieldset>
          <fieldset>
            <legend>Timeline</legend>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  label={
                    <>
                      Start Time (UTC)
                      <Tooltip
                        title={
                          <div className="tooltip-box">
                            <p className="tooltip-text">
                              This is your Airdrop start time pool. You can start to claim reward
                              after this time.
                            </p>
                          </div>
                        }
                        placement="right"
                        overlayInnerStyle={{
                          backgroundColor: '#ffffff',
                        }}
                      >
                        <QuestionCircleOutlined className="tooltip-icon" />
                      </Tooltip>
                    </>
                  }
                  name="startDate"
                  rules={[{ required: true, message: 'Please select date!' }]}
                >
                  <DatePicker
                    disabled={!edit}
                    minDate={dayjs()}
                    maxDate={endDate}
                    showTime
                    value={startDate}
                    onChange={(value) => setStartDate(value)}
                    use12Hours
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label={
                    <>
                      End Time (UTC)
                      <Tooltip
                        title={
                          <div className="tooltip-box">
                            <p className="tooltip-text">
                              This is your Airdrop end time pool. You can&apos;t claim reward after
                              this time.
                            </p>
                          </div>
                        }
                        placement="right"
                        overlayInnerStyle={{
                          backgroundColor: '#ffffff',
                        }}
                      >
                        <QuestionCircleOutlined className="tooltip-icon" />
                      </Tooltip>
                    </>
                  }
                  name="endDate"
                  rules={[{ required: true, message: 'Please select date!' }]}
                >
                  <DatePicker
                    disabled={!edit}
                    minDate={startDate || dayjs()}
                    showTime
                    value={endDate}
                    onChange={(value) => setEndDate(value)}
                    use12Hours
                  />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
          <fieldset>
            <legend>Upload Picture</legend>
            <Row gutter={24}>
              <Col style={{ position: 'relative' }} span={12}>
                {thumbnail.length > 0 && (
                  <>
                    <img style={{ width: '50%', border: '1px solid' }} src={thumbnail} alt="" />
                    <CloseOutlined
                      style={{
                        position: 'absolute',
                        top: 4,
                        right: '50%',
                        color: '#000',
                        fontSize: '16px',
                        cursor: 'pointer',
                        background: 'white',
                        borderRadius: '50%',
                        padding: '2px',
                        border: '1px solid',
                        display: edit ? 'unset' : 'none',
                      }}
                      onClick={() => {
                        setThumbnail('')
                        setSingleFile([])
                      }}
                    />
                  </>
                )}
              </Col>
              <Col span={12}></Col>
              {edit && (
                <Col style={{ marginBottom: 20, marginTop: 20 }} span={12}>
                  <div style={{ marginBottom: 10 }}>
                    <span style={{ color: 'red' }}>*</span> Upload new banner{' '}
                    <Tooltip
                      title={
                        <div className="tooltip-box">
                          <p className="tooltip-text">
                            This is your Airdrop banner. Please upload your chosen image.
                          </p>
                        </div>
                      }
                      placement="right"
                      overlayInnerStyle={{
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <QuestionCircleOutlined className="tooltip-icon" />
                    </Tooltip>
                  </div>
                  <Form.Item name="uploadSingle">
                    <Upload
                      accept=".jpg,.jpeg,.png"
                      fileList={singleFile}
                      customRequest={handleUploadSingle}
                      beforeUpload={beforeUploadSingle}
                    >
                      <Button icon={<UploadOutlined />}>Upload Photo</Button>
                    </Upload>
                  </Form.Item>
                  <p>You can only upload JPG/PNG file.</p>
                  <p>The image should have the size of 500x200 px.</p>
                </Col>
              )}
            </Row>
          </fieldset>
        </Form>
      )}
      {tab === 1 && (
        <>
          <div className="dashboard-container">
            <div className="wrap-dashboard">
              <div className="wrap-box">
                <div className="title">Airdrop Overview</div>
                <div className="wrap-columns">
                  <div className="columns">
                    <div className="colum w-3">
                      <div className="guide-box">
                        <div className="box-content">
                          <div className="left-s">
                            <div className="txt">Total Users</div>
                            <div className="number">
                              {new Intl.NumberFormat('en-US').format(totalUser)}
                            </div>
                          </div>
                          <div className="right-s">
                            <div className="icon">
                              <UserOutlined />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="colum w-3">
                      <div className="guide-box">
                        <div className="box-content">
                          <div className="left-s">
                            <div className="txt">Total Token</div>
                            <div className="number">
                              {new Intl.NumberFormat('en-US').format(totalToken)}
                            </div>
                          </div>
                          <div className="right-s">
                            <div className="icon">
                              <DollarOutlined />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {canCRUD(FEATURE.AIRDROP) && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'ce',
              }}
            >
              <div className="export-files">
                <Upload
                  disabled={!contract?.address}
                  fileList={file}
                  customRequest={handleUpload}
                  showUploadList={false}
                >
                  <Button
                    size="large"
                    type="primary"
                    icon={<UploadOutlined />}
                    disabled={isUploading || !contract?.address || (contract?.address && !isOwner)}
                  >
                    {isUploading ? 'Uploading...' : 'Upload Whitelist CSV file'}
                  </Button>
                </Upload>
                <p className="download-link" onClick={handleDownload}>
                  Example CSV file
                </p>
              </div>
              <div className="export-files">
                <Button
                  type="primary"
                  style={{ width: 300 }}
                  disabled={
                    loadingContract || !contract?.address || (contract?.address && !isOwner)
                  }
                  onClick={() => {
                    if (contract?.address) importWhiteList()
                    else handleConnect()
                  }}
                  size="large"
                  icon={loadingContract ? undefined : <UploadOutlined />}
                >
                  {loadingContract ? <Spin /> : 'Import Whitelist to contract'}
                </Button>
              </div>
            </div>
          )}
          <div className="user-search">
            <input
              type="text"
              placeholder="Address"
              value={addressSearch}
              onChange={(e) => setAddressSearch(e.target.value)}
            />
            <Button type="primary" onClick={() => getWhiteList(current, pageSize)}>
              Search
            </Button>
          </div>
          <Card style={{ margin: '0 auto' }}>
            <Table<any>
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={total < 11 ? false : { total, current, pageSize }}
              // pagination={{ total, current, pageSize }}
              onChange={handleTableChange}
              scroll={{ x: 1000 }}
              bordered
            />
          </Card>
          <Modal
            title={false}
            visible={loadingContract}
            footer={false}
            wrapClassName="modal-confirm"
            centered
          >
            <p className="spin-stake">
              <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 60 }} spin />} />
            </p>
            <p className="modal-text1">Your request is being processed. Please wait...</p>
            <Progress
              percent={Math.round((processedWallets / fullAddressList.length) * 100)}
              status="active"
              strokeWidth={10}
            />
            <div className="modal-text2">
              <p>
                {/* {allBatches.map((batch) => (
                <div key={batch.batch}>
                  {batch.status === 'Success' ? `${batch.range} wallets: Success` : `${batch.range} wallets: ${batch.status}`}
                </div>
              ))} */}
                <div>
                  Processing: {processedWallets}/{fullAddressList.length} wallets
                </div>
              </p>
            </div>
          </Modal>
        </>
      )}
    </div>
  )
}
